module.exports = __webpack_public_path__ + "static/media/as-alonso-stanzani-advogados-associados-cartao-visita.8b201704.jpg";